const registerStaffES = {
	step: "Paso {{step}} de 3",

	step1: {
		title: "Crear cuenta",
		subtitle: "Te invitaron a unirte a un equipo en Sin Fila. Elige una contraseña para empezar.",
		invitedTo: "Te unes como",
		sectionAbout: "Sobre ti",
		sectionSecurity: "Seguridad",
		firstName: "Nombre",
		lastName: "Apellido",
		phone: "Número de teléfono",
		password: "Contraseña",
		confirmPassword: "Confirmar contraseña",
		remember: "Recordarme",
		register: "Registrar",
		registering: "Registrando...",
		acceptTerms: "Acepto los",
		termsLink: "Términos y Condiciones",
		email: "Correo electrónico",
	},

	step2: {
		title: "Registra tu negocio",
		shopName: "Nombre del negocio",
		address: "Dirección",
		city: "Ciudad",
		country: "País",
		postalCode: "Código postal",
		description: "Descripción",
		category: "Tipo de negocio",
		openingHours: "Horario de apertura",
		closed: "Cerrado",
		socials: "Redes sociales (opcional)",
		instagram: "URL de Instagram",
		facebook: "URL de Facebook",
		tiktok: "URL de TikTok",
		website: "Sitio web",
		next: "Siguiente paso",
		registering: "Registrando...",
	},

	step3: {
		title: "Servicios y fotos",
		description: "Agrega al menos un servicio para finalizar el registro.",
		photos: "Fotos del portafolio",
		upload: "Subir fotos",
		finish: "Finalizar registro",
		registering: "Registrando...",
	},

	errors: {
		fillRequired: "¡Casi listo! Completa los campos obligatorios para continuar.",
		passwordMatch: "Las contraseñas no coinciden. Revísalas e inténtalo de nuevo.",
		uploadImages: "Agrega al menos una foto para finalizar tu registro.",
		invalidInvite: "Este enlace de invitación ya no es válido o expiró. Solicita uno nuevo.",
		mustAcceptTerms: "Necesitamos que aceptes los Términos y Condiciones para continuar.",
	},

	success: {
		adminCreated: "¡Listo! Tu cuenta está creada — ahora registremos tu negocio.",
		returning: "¡Qué bueno verte de nuevo! Sigamos registrando tu negocio.",
	},

	days: {
		Monday: "Lunes",
		Tuesday: "Martes",
		Wednesday: "Miércoles",
		Thursday: "Jueves",
		Friday: "Viernes",
		Saturday: "Sábado",
		Sunday: "Domingo",
	},
};

export default registerStaffES;
